module.exports = __webpack_public_path__ + "img/kufri-beige.34ceba0.webp";